const tours = {
  availableEscapes: "Escapes Disponibles", // translated
  sendRequest: "Enviar petición", // translated
  getRequest: "Obtener solicitud", // translated
  addOns: "Complementos", // translated
  tour: "Recorrido", // translated
  addOn: "Añadir", // translated
  availableExperiences: "Experiencias disponibles", // translated
  selectRoom: "Selecciona una habitación", // translated
  tours: "Excursiones", // translated
};


export default tours;
